export default "__VITE_ASSET__$F4rh2ax__"